<template>
  <section class="organization posire">
    <section class="posiab orgBox">
      <qx-card title="车辆列表">
        <span slot="titleRight">车辆数：{{vehicleCount}}</span>
        <el-input v-model="plateNumber"
                  placeholder="请输入车牌号"
                  size="medium"
                  @keyup.enter.native="getData"
                  @clear="getData"
                  @blur="getData"
                  clearable
                  prefix-icon="el-icon-search"
        ></el-input>
        <el-tree
            :data="treeData"
            :show-checkbox="false"
            node-key="id"
            ref="tree"

            :props="defaultProps"
            :default-expanded-keys="[1]"
            :expand-on-click-node="true"
            @node-click="handleNodeClick"
            highlight-current
        >
        </el-tree>
      </qx-card>
    </section>
    <StatisticsSearch ref="statisticsSearch" @setCurrentKey="setCurrentKey"></StatisticsSearch>
  </section>
</template>

<script>
import StatisticsSearch from './statisticsSearch';
import {vehicleList} from 'api/service';
export default {
  components: {StatisticsSearch},
  data () {
    return {
      plateNumber: '',
      // treeData: [
      //   {
      //     label: '所有车辆',
      //     id: 1,
      //     children: [{
      //       label: '燃油车',
      //       id: 1,
      //       children: [{
      //         label: '陕A13579',
      //       }],
      //     },
      //     {
      //       label: '燃气车',
      //       id: 2,
      //       children: [{
      //         label: '陕A24680',
      //       }],
      //     },
      //     ],
      //   },
      // ],
      vehicleCount: 0,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    };
  },
  methods: {
    handleNodeClick (data, item) {
      if (data.label !== '暂无数据') {
        this.$refs.statisticsSearch.setData(data, item);
      }
    },
    setCurrentKey (val, vehicleType) {
      if (val === '按日期' && vehicleType === 1) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0].children[0].id);
        });
      } else if (val === '按日期' && vehicleType === 2) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0].children[1].id);
        });
      }
    },
    async getData () {
      const res = await vehicleList({
        plateNumber: this.plateNumber,
      });
      this.treeData = res;
      let count = 0;
      if (res[0].children) {
        res.forEach((item) => {
          item.children.map((itemChild) => {
            if (itemChild.children && itemChild.children.length > 0) {
              count += itemChild.children.length;
            }
          });
        });
        this.vehicleCount = count;
      } else {
        this.vehicleCount = 0;
      }
    },
  },
  async created () {
    await this.getData();
    await this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(this.treeData[0].children[0].id);
    });
  },
};
</script>

<style scoped lang="scss">
.organization {
  padding-left: 258px;
  .orgBox {
    width: 250px;
    height: 100%;
    top: 0;
    left: 0;
    .treeNodeBox {
      width: 100%;
      .btn {
        margin-left: 16px;
      }
    }
  }
  ::v-deep .el-tree-node__content {
    .btnBox {
      display: none;
    }
  }
  ::v-deep .el-tree-node__content:hover {
    .btnBox {
      display: block;
    }
  }

  //// 设置高亮颜色
  //::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  //  background-color: #baf !important;
  //}
}
</style>
